import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-down-tri",
  "use": "icon-down-tri-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-down-tri\"><defs><style type=\"text/css\"></style></defs><path d=\"M256 384l256 256 256-256z\" p-id=\"17351\" fill=\"#ffffff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol